import { render, staticRenderFns } from "./GroupBooking.vue?vue&type=template&id=6ca2206f&scoped=true"
import script from "./GroupBooking.vue?vue&type=script&lang=js"
export * from "./GroupBooking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca2206f",
  null
  
)

export default component.exports